import { PartialType, PickType } from '@nestjs/swagger';
import { SubdivisionSupervisorDto } from './subdivision-supervisor.dto';
import { SubdivisionSupervisorCreatableInterface } from '../interfaces/subdivision-supervisor-creatable.interface';

export class SubdivisionSupervisorCreateDto
  extends PartialType(
    PickType(SubdivisionSupervisorDto, ['userId', 'subdivisionId']),
  )
  implements SubdivisionSupervisorCreatableInterface {}
